import script from "./GalleryPhotoList.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryPhotoList.vue?vue&type=script&setup=true&lang=js"

import "./GalleryPhotoList.vue?vue&type=style&index=0&id=3ea48c36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ea48c36"]])

export default __exports__